import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Phone, Shield, Clock, Check } from 'lucide-react';
import { Button } from '../ui/button';

const FinalCTA = () => {
  const whatsappLink = "https://wa.me/919353316112?text=Hi%20LitheForce!%20I'm%20interested%20in%20your%20AI%20solutions.";

  const trustBadges = [
    { icon: Shield, text: 'No credit card required' },
    { icon: Check, text: 'No obligation' },
    { icon: Clock, text: 'Same-day response' },
  ];

  return (
    <section className="py-20 md:py-32 bg-gradient-to-br from-[#1a237e] via-[#1a237e] to-[#0d1352] relative overflow-hidden" data-testid="final-cta-section">
      {/* Background decorations */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#00e5ff]/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-[#ff6d00]/10 rounded-full blur-3xl" />
      </div>

      <div className="section-container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="final-cta-headline"
          >
            Ready to Build Something Amazing?
          </h2>
          <p className="text-lg md:text-xl text-white/80 mb-8">
            Book a free 15-minute consultation. No sales pitch—just an honest conversation about your needs.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button
                className="btn-primary text-lg px-8 py-4 h-auto flex items-center gap-2"
                data-testid="final-cta-primary-btn"
              >
                <MessageCircle className="w-5 h-5" />
                Book Free Consultation
              </Button>
            </a>
          </div>

          {/* WhatsApp Link */}
          <div className="flex items-center justify-center gap-2 text-white/80 mb-8">
            <Phone className="w-4 h-4" />
            <span>Or WhatsApp us: </span>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#00e5ff] hover:underline font-medium"
              data-testid="whatsapp-link"
            >
              +91 9353316112
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            {trustBadges.map((badge, index) => (
              <div key={index} className="flex items-center gap-2 text-white/70">
                <badge.icon className="w-4 h-4 text-[#00e5ff]" />
                <span className="text-sm">{badge.text}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
